import React, { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { getFirebaseAuthModule } from "../../Repository/Authentication/Firebase";
import { useAuthUser } from "../../Context/AuthUserContext";
import {
  clearPendingQrReturn,
  verifyCamiCodeScan,
} from "../../Business/CamiCodeScanBusiness";
import Watch from "./Watch";

export default function SponsorWatchGate() {
  const navigate = useNavigate();
  const location = useLocation();
  const { authReady, profileLoading, isLoggedIn, profile, refreshProfile } = useAuthUser();
  const [gateReady, setGateReady] = useState(false);

  const params = new URLSearchParams(location.search);
  const camiCode = params.get("c");
  const password = params.get("p");
  const playConfirmed = params.get("play") === "1";
  const shouldRunOwnerGate = !!(camiCode && password && !playConfirmed);

  const getOptionalAuthHeaders = () => {
    const token = localStorage.getItem("JWTTOKEN");
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  useEffect(() => {
    let cancelled = false;

    async function runOwnerGate() {
      if (!shouldRunOwnerGate) {
        setGateReady(true);
        return;
      }

      if (!authReady || (isLoggedIn && profileLoading && !profile)) {
        return;
      }

      try {
        const auth = getFirebaseAuthModule();
        let activeProfile = profile;
        if (isLoggedIn && (!activeProfile || activeProfile.id == null)) {
          try {
            activeProfile = (await refreshProfile()) || activeProfile;
          } catch {
            /* keep existing profile */
          }
        }

        const authUser =
          auth.currentUser ||
          (isLoggedIn && activeProfile?.email ? { email: activeProfile.email } : null);

        const redirParam = params.get("redir");
        const redirPath = redirParam ? decodeURIComponent(redirParam) : "/";

        const outcome = await verifyCamiCodeScan({
          camiCode,
          password,
          getAuthHeaders: getOptionalAuthHeaders,
          authUser,
          profile: activeProfile,
          redirPath,
          showOwnerOptions: true,
        });

        if (cancelled) {
          return;
        }

        if (outcome.action === "owner-options") {
          clearPendingQrReturn();
          navigate(
            `/scan-qr?c=${encodeURIComponent(camiCode)}&p=${encodeURIComponent(password)}`,
            { replace: true }
          );
          return;
        }

        if (outcome.action === "login") {
          navigate("/login", { state: outcome.loginState, replace: true });
          return;
        }

        if (outcome.action === "upload") {
          clearPendingQrReturn();
          navigate(outcome.url, { replace: true });
          return;
        }

        setGateReady(true);
      } catch {
        if (!cancelled) {
          setGateReady(true);
        }
      }
    }

    setGateReady(false);
    runOwnerGate();

    return () => {
      cancelled = true;
    };
  }, [
    shouldRunOwnerGate,
    camiCode,
    password,
    authReady,
    isLoggedIn,
    profileLoading,
    profile,
    refreshProfile,
    navigate,
    location.search,
  ]);

  if (!authReady || (isLoggedIn && profileLoading && !profile)) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "fixed",
          inset: 0,
          height: "100dvh",
          overflow: "hidden",
          bgcolor: "#000",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (shouldRunOwnerGate && !gateReady) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "fixed",
          inset: 0,
          height: "100dvh",
          overflow: "hidden",
          bgcolor: "#000",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return <Watch />;
}
